import { Document, Page } from 'react-pdf';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { Dispatch, SetStateAction, useState, useRef, useEffect } from 'react';
import LoadingWheel from '../../../../components/core/LoadingWheel/LoadingWheel';
import { Config } from '../../../../config';
import useServiceContractPdfStyles from './ServiceContractPdf.styles';

export interface IServiceContractPdfProps {
    setEndOfDocumentReached: Dispatch<SetStateAction<boolean>>;
}
const ServiceContractPdf = (props: IServiceContractPdfProps) => {
    const serviceAgreementFile = `/data/viaero-service-agreement.pdf`;
    const { setEndOfDocumentReached } = props;

    const styles = useServiceContractPdfStyles();

    const [allPageNumbers, setAllPageNumbers] = useState<number[]>();
    const PAGE_MAX_HEIGHT = 524;
    const [outerWidth, setOuterWidth] = useState<number>(0);
    const pdfContainerRef = useRef<HTMLDivElement>(null);
    const pageContainerRef = useRef<HTMLDivElement>(null);

    // Update width when component mounts and on window resize
    useEffect(() => {
        const updateWidth = () => {
            if (pdfContainerRef.current) {
                setOuterWidth(pdfContainerRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const onDocumentLoadSuccess = (pdf: PDFDocumentProxy) => {
        const allPageNumbers: number[] = [];
        for (let p = 1; p < pdf.numPages + 1; p++) {
            allPageNumbers.push(p);
        }
        setAllPageNumbers(allPageNumbers);

        if (pdfContainerRef.current) {
            setOuterWidth(pdfContainerRef.current.offsetWidth);
        }
    };

    const handlePdfScroll = () => {
        const element = pageContainerRef.current;
        if (!element?.scrollHeight || !element?.offsetHeight || !element?.scrollTop) return;
        const scrollPosition = element.scrollTop;
        const endOfDocument = element.scrollHeight - element.offsetHeight;
        if (Math.abs(endOfDocument - scrollPosition) <= 50) setEndOfDocumentReached(true);
    };

    return (
        <div ref={pdfContainerRef} className={styles.pdfContainer}>
            <Document
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<LoadingWheel />}
                error={<h2>Unable to load PDF.</h2>}
                file={`${Config.url.STORAGE_URL}${serviceAgreementFile}`}
            >
                <div
                    ref={pageContainerRef}
                    className={styles.pageContainer}
                    style={{
                        maxHeight: `${PAGE_MAX_HEIGHT}px`
                    }}
                    onScroll={handlePdfScroll}
                >
                    {allPageNumbers
                        ? allPageNumbers.map((pn) => (
                              <Page
                                  renderTextLayer={false}
                                  renderAnnotationLayer={false}
                                  key={`page-${pn}`}
                                  width={outerWidth}
                                  pageNumber={pn}
                              />
                          ))
                        : undefined}
                </div>
            </Document>
        </div>
    );
};

export default ServiceContractPdf;
